<template>
  <div>
    <!--GERAR NOVO LOTE -->
    <ed-modal
      :title="'Gerar Novo Lote'"
      :modal="showFormEdit"
      :loadingSave="config.loading.save"
      :onSave="salvar"
      width="98%"
    >
      <div slot="modal-content" v-loading="config.loading.content">
        <ed-form :model="formData">
          <ed-input-auto-complete
            class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pa-0"
            label="Empresa"
            placeholder="Pesquisar empresa"
            v-model="formData.id_emp"
            :items="config.list.id_emp"
            :loading="config.loading.id_emp"
            @search="getEmpresa"
            clearable
            required
          />
          <ed-input-auto-complete
            class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pa-0"
            label="Layout"
            placeholder="Pesquisar layout"
            v-model="formData.layout"
            :items="config.list.layout"
            :loading="config.loading.layout"
            itemText="esocial"
            @search="getLayout"
            is-object
            clearable
            required
          />

          <div
            class="
              col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12
              pt-3
              text-left
            "
          >
            <b>Aplicar outros filtros</b>
          </div>

          <ed-input-auto-complete
            class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 pa-0"
            label="Frente de Trabalho"
            v-model="formData.fdts"
            :items="config.list.id_fdt"
            :loading="config.loading.id_fdt"
            @search="getFdt"
            :disabled="!formData.id_emp || !formData.layout"
            itemText="fdt"
            clearable
            multiple
          />

          <ed-input-auto-complete
            class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 pa-0"
            label="Funcionário"
            v-model="formData.funcionarios"
            :items="config.list.id_fun"
            :loading="config.loading.id_fun"
            :disabled="!formData.id_emp || !formData.layout"
            @search="getFuncionario"
            clearable
            multiple
          />

          <ed-input-date
            class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4"
            label="Data de cadastro do arquivo"
            type="daterange"
            v-model="formData.created_at"
            :disabled="
              !formData.id_emp ||
              !formData.layout
            "
          />

          <ed-input-auto-complete
            class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 pa-0"
            label="Não incluir os seguintes funcionários"
            v-model="formData.funcionarios_delete"
            :items="config.list.id_fun"
            :loading="config.loading.id_fun"
            :disabled="!formData.id_emp || !formData.layout"
            @search="getFuncionario"
            clearable
            multiple
          />

          <ed-input-select
            class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 pa-0"
            label="Somente eventos avulsos"
            v-model="formData.avulso"
            :items="[{id:1,nome:'Sim'},{id:0,nome:'Não'}]"
            :disabled="!formData.id_emp || !formData.layout"
            @search="getFuncionario"
            clearable
          />
        </ed-form>
      </div>
    </ed-modal>
  </div>
</template>

<script>
import Rest from "common/rest";

import { EdForm, EdModal, EdInputAutoComplete, EdInputSelect,EdInputDate } from "template";

export default {
  name: "esocial-lotes",
  mixins: [Rest],
  components: {
    EdModal,
    EdForm,
    EdInputAutoComplete,
    EdInputSelect,
    EdInputDate,
  },
  props: {
    parent: {
      type: Object,
      default: function () {
        return {};
      },
    },
    showForm: {
      type: Boolean,
      default: function () {
        return false;
      },
    },
  },
  watch: {
    showForm() {
      this.showFormEdit = !this.showFormEdit;
    },
    "formData.id_emp"() {
      this.getFdt();
      this.getFuncionario();
    },
  },
  data() {
    return {
      config: {
        loading: {
          save: false,
          id_emp: false,
          layout: false,
          id_fdt: false,
          id_fun: false,
        },
        list: {
          id_emp: [],
          layout: [],
          id_fdt: [],
          id_fun: [],
        },
      },
      response: {},
      pagination: {},
      formData: {
        id_emp: null,
        layout: null,
        avulso:0,
        created_at: [],
        fdts: [],
        funcionarios: [],
        funcionarios_delete:[]
      },
      showFormEdit: false,
    };
  },

  created() {},

  mounted() {
    this.getLayout();
    this.getEmpresa();
  },

  methods: {
    getEmpresa: function (_search) {
      this.config.loading.id_emp = true;
      this.config.list.id_emp = [];

      this.get("/empresa", { search: _search }).then((result) => {
        result = result[0];
        this.config.loading.id_emp = false;

        if (result.status == 200) {
          this.config.list.id_emp = result.data.data;
        }
      });
    },

    getFdt: function (_search) {
      if (!this.formData.id_emp) return;

      this.config.loading.id_fdt = true;
      this.config.list.id_fdt = [];

      this.get("pcmso/fdt/" + this.formData.id_emp, { search: _search }).then(
        (result) => {
          result = result[0];
          this.config.loading.id_fdt = false;

          if (result.status == 200) {
            this.config.list.id_fdt = result.data.data;
          }
        }
      );
    },

    getFuncionario: function (_search) {
      if (!this.formData.id_emp) return;

      this.config.loading.id_fun = true;
      this.config.list.id_fun = [];

      this.get("/empresa/funcionario/" + this.formData.id_emp, {
        search: _search,
      }).then((result) => {
        result = result[0];

        this.config.loading.id_fun = false;

        if (result.status == 200) {
          this.config.list.id_fun = result.data.data;
        }
      });
    },
    getLayout: function (_search) {
      this.config.loading.layout = true;
      this.config.list.layout = [];

      this.get("esocial/tabelas/conteudo/9", { search: _search }).then(
        (result) => {
          result = result[0];

          this.config.loading.layout = false;

          if (result.status == 200) {
            this.config.list.layout = result.data.data;
          }
        }
      );
    },

    salvar() {
      this.$confirm(
        "O sistema já faz esta verificação diariamente automaticamente e cria os lotes necessários. Deseja verificar agora se existem novos lotes?",
        "Atenção",
        {
          type: "warning",
        }
      ).then(() => {
        this.config.loading.save = true;
        this.response = {};

        var filter = {
          id_empresa: this.formData.id_emp,
          created_at: this.formData.created_at,
          fdts: this.formData.fdts,
          funcionarios: this.formData.funcionarios,
          funcionarios_delete:this.formData.funcionarios_delete,
          avulso:this.formData.avulso
        };


        this.get("esocial/lotes/gerar/" + this.formData.layout.codigo, {
          filter: filter,
        }).then((result) => {
          this.config.loading.save = false;

          result = result[0];
          this.response = result;

          if (result.status == 200) {
            this.showFormEdit = !this.showFormEdit;

            if (this.parent.getEsocialLotes) this.parent.getEsocialLotes();

            this.edAlert(
              "Processo de cadastro do LOTE iniciado em segundo plano. Aguarde alguns instantes e acesse eSocial > Lotes para acompanhar o processo."
            );
          } else {
            this.edAlert(result.msg, "error");
          }
        });
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// gerar.vue?1aa87ec8